import { Link } from "react-router-dom";

export default function FloatingFilterBar({ onOpenFilter, onOpenSort }) {
  return (
        <div
      className="
        fixed bottom-4 left-1/2 -translate-x-1/2
        w-[90%] sm:w-auto
        flex items-center justify-center gap-4
        bg-black/20 backdrop-blur-xxl
        px-4 py-3 rounded-full z-40
      "
    >
      <div className="bg-black  text-white rounded-full shadow-lg px-2 py-2 flex gap-4">
        <button onClick={onOpenSort} className="px-6 py-2 rounded-full  hover:bg-white/30 hover:shadow-lg hover:scale-105">SORT</button>
        <button onClick={onOpenFilter} className="px-6 py-2 rounded-full flex items-center gap-2  hover:bg-white/30 hover:shadow-lg hover:scale-105">
          FILTER
        </button>
      </div>

      
    </div>
  );
}
